import { Button, Icon, Theme } from "@outschool/backpack";
import { faChartSimpleRegular } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

const LEGACY_PRIMARY_COLOR = "#6161F2";
interface CompareButtonProps {
  disabled: boolean;
  onClick: () => void;
}

export default function CompareFromSearchButton({
  disabled,
  onClick,
}: CompareButtonProps) {
  const { t } = useTranslation(
    "client\\components\\search\\CompareFromSearchButton",
  );
  const isMobile = useIsMobile();

  return (
    <Button
      size="small"
      color={isMobile ? "primary" : "neutral"}
      startIcon={<Icon icon={faChartSimpleRegular} />}
      onClick={onClick}
      disabled={disabled}
      sx={(theme: Theme) => ({
        borderWidth: "2px !important",
        [theme.breakpoints.up("md")]: {
          paddingTop: "7px",
          paddingBottom: "7px",
        },
        "&:hover:not(:disabled), &:focus:not(:disabled)": {
          borderColor: LEGACY_PRIMARY_COLOR,
          backgroundColor: "#E0E5FF",
        },
        "&:disabled": {
          borderColor: "grey !important",
        },
        [theme.breakpoints.down("md")]: {
          color: LEGACY_PRIMARY_COLOR,
          backgroundColor: "white",
          borderColor: LEGACY_PRIMARY_COLOR,
          height: "34px",
          fontSize: "14px",
          "&:disabled": {
            color: "grey !important",
          },
          paddingX: "0.75em",
        },
      })}
    >
      {t`Compare`}
    </Button>
  );
}
